import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency } from '../../../../config/constants';

export class RequestDeposit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            depositAmount: ''
        }
    }

    reqDep = (depValue) => {

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');



        let orderUpdates = {
            depositRequested: depValue,
            depositRequestedDateNum: d.getTime(),
            depositRequestedTime: now,
            depositAmount: this.state.depositAmount
        }
        FbUtils.updateOrder(getOrderKey(this.props.order) , orderUpdates);

        let updateText = "deposit:"+toCurrency(this.state.depositAmount)+" -"+this.props.user.email.substring(0,10);
       // let updateText = "deposit:"+this.state.depositAmount+"- "+this.props.user.email.substring(0,10);
        FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);

        if (this.props.searchNow) {
            console.log("upx771001 updateCommentFormSubmit searchnow is true call refresh after time out.");

            setTimeout(this.props.setRefreshToTrue, 5000);
            setTimeout(this.props.setRefreshToFalse, 10000);

            // setTimeout(function() { this.props.setRefreshToTrue; }, 2000);
            // setTimeout(function() { this.props.setRefreshToFalse; }, 4000);
        }

        axios.post(serverIp + 'deposit/markDeposit', {
            apiKey: "asdf@asdfasdf",
            fbOrderKey: getOrderKey(this.props.order),
            adminEmail: this.props.user.email,
            depositStatus: depValue,
            depositAmount: this.state.depositAmount
        })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    handleTextChange = (e) => {
        console.log("dx32 e.target.name:" + e.target.name);
        console.log("dx34 e.target.value:" + e.target.value);

        this.setState({
            depositAmount: e.target.value
        })
    }


    setReq = () => {
        this.reqDep("required");
    }

    setNotRequired = () => {
        this.reqDep("notReq");
    }

    setDepRequested = () => {
        this.reqDep("requested");
    }

    setDepPaid = () => {
        this.reqDep("paid");
    }

    render() {

        // const showButton = this.props.order.depositRequested
        //     && (this.props.order.depositRequested === true || this.props.order.depositRequested === "true" || this.props.order.depositRequested === "required")
        //     && this.props.user.email === 'ivanmworozi@gmail.com'
        //     ? <h3> DEPOSIT REQUEST </h3>
        //     : <Button onClick={this.setReq}> REQ DEP </Button>

        // const showNotNeeded = (this.props.order.depositRequested === "no" || this.props.order.depositRequested === "notReq") && this.props.order.depositRequested !== "requested"
        //     && this.props.user.email === 'ivanmworozi@gmail.com'
        //     ? <h5> DEPOSIT NOT NEEDED </h5>
        //     : <Button onClick={this.setNotRequired}> NO DEP REQ </Button>

        // const showDepRequested = this.props.order.depositRequested === "requested"
        //     ? <h5> DEPOSIT REQUESTED </h5>
        //     : <Button color='teal' onClick={this.setDepRequested}> DEPOSIT BEEN REQUSTD </Button>


        const payButton = this.state.depositAmount !== ''
            ? <Button color='green' onClick={this.setDepPaid}> LOG DEP PAID </Button>
            : ''

        const requestDepositUI = this.props.order.depositAmount
            ? ''
            : <div>
                {/* {showButton} */}
                {/* {showNotNeeded} */}
                {/* {showDepRequested} */}
            </div>

        const showDepPaid = this.props.order.depositRequested === "paid"
            ? <h5> DEPOSIT PAID - {this.props.order.depositAmount} </h5>
            : <div>
                <Form.Input
                    fluid
                    icon='money'
                    iconPosition='left'
                    placeholder='Amount'
                    type='number'
                    name="depositAmount"
                    value={this.state.depositAmount}
                    onChange={this.handleTextChange}
                />
                {payButton}

            </div>


        return (
            <div>
                <Divider horizontal>{'DEPOSIT'}</Divider>
                {requestDepositUI}
                {showDepPaid}
            </div>
        )
    }
}

export default RequestDeposit;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Deposits/RequestDeposit.js